<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <v-card class="shadow-none">
            <v-card-text>
                <div v-html="dcontent.data.content">
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import * as logs from '../../assets/log_process.js'

export default {
    data() {
        return {
            startTime : null
        }
    },
    props: {
        dcontent: Object,
        taskIndex: Number
    },
    mounted() {
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
        // write passed
        if (!this.dcontent.passed) {
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: 0})            
        }
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }

}
</script>
